module.exports = __webpack_public_path__ + "static/media/L&T_Mutual_Fund.e70dec54.pdf";